<template>
    <div id="primary-impact">

        <!--=====================================-->
        <!--=        Banner Area Start          =-->
        <!--=====================================-->
        <section class="section mb--80">
            <div class="container">
                <div class="row text-align-last text-align-center">
                    <div class="col-12 align-self-center">
                        <div class="banner-content">
                            <!-- <h1 class="subtitle primary mb-0" data-sal="slide-up" data-sal-duration="1000"
                                data-sal-delay="200">¿Cómo medimos el impacto?</h1>
                            <h2 class="font-weight-100" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
                                Descubre el <span class="bold">impacto</span> que junt@s hemos creado.
                            </h2> -->
                            <p class="body-font1" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
                                Da clic en cada color para obtener más información <br>
                                sobre la <span class="bold">ODS</span> de tu interés.
                            </p>
                        </div>
                    </div>
                    <div data-sal="slide-left" data-sal-duration="1000" data-sal-delay="200" class="col-12 fix-chart">
                        <div class="banner-thumbnail">
                            <div id="chart">
                                <VueApexCharts v-if="isCreated" type="donut" :options="chartOptions" :series="series"></VueApexCharts>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--=====================================-->
        <!--=      ESFUERZOS COLECTIVOS         =-->
        <!--=====================================-->
        <section class="section faq-area mb--100">
            <div class="container">            
                <!-- EN ESTE APARTADO VA EL TEMA DE LOS ODS QUE CAMBIAN CON LA SELECCIÓN DE LA GRÁFICA -->
                <div class="row" :class="targetId != null ? 'mb--90' : ''">
                    <div class="col-sm-12 col-md-10 col-lg-12">
                        <div class="faq-accordion">
                            <div class="accordion" id="accordion">
                                <!-- ODS 1 - red -->
                                <div v-show="showOds(1)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods01" aria-expanded="true"
                                        aria-controls="ods01" :color="redOds01" :imgName="'01'" ods="ODS 1"
                                        title="Fin de la pobreza." :capital="mxnFormat(0)" />
                                </div>

                                <!-- ODS 2 - pink -->
                                <!-- <div class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods02" aria-expanded="false"
                                        aria-controls="ods02" :color="yellow2" :imgName="'02'" ods="ODS 2"
                                        title="Hambre cero." :capital="mxnFormat(0)" />
                                </div> -->

                                <!-- ODS 3 - green -->
                                <div v-show="showOds(3)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods03" aria-expanded="true"
                                        aria-controls="ods03" :color="green03" :imgName="'03'" ods="ODS 3"
                                        title="Salud y bienestar." :capital="mxnFormat(0)" />
                                </div>
                                <!-- ODS 4 - blue -->
                                <div v-show="showOds(4)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods04" aria-expanded="true"
                                        aria-controls="ods04" :color="redOds04" :imgName="'04'" ods="ODS 4"
                                        title="Educación de calidad." :capital="mxnFormat(0)" />
                                </div>

                                <!-- ODS 5 - red -->
                                <div v-show="showOds(5)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods5" aria-expanded="true"
                                        aria-controls="ods5" :color="red" :imgName="'05'" ods="ODS 5"
                                        title="Igualdad de género." :capital="mxnFormat(getOds5TotalAum)" />
                                    <div id="ods5" class="accordion-collapse collapse show" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <!-- 5.a -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="true"
                                                :icon1="'resiliencia'" :icon2="null" :icon3="'secondary'">
                                                <template v-slot:title>
                                                    Meta ODS 5.a - Financiamiento con perspectiva de género.
                                                </template>
                                                <template v-slot:goal>
                                                    Adaptación y resiliencia
                                                </template>
                                                <template v-slot:description>
                                                    <h4 class="font-weight-100">
                                                        Emprender reformas que otorguen a las <span class="bold">mujeres
                                                            igualdad de derechos</span> a los recursos económicos, así como
                                                        acceso a la propiedad y al control de la tierra y otros tipos de
                                                        bienes, los <span class="bold">servicios financieros</span>, la
                                                        herencia y los recursos
                                                        naturales, de conformidad con las leyes nacionales.
                                                    </h4>
                                                </template>
                                                <template v-slot:line-action-title>
                                                    <strong>Créditos a mujeres.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in generalColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Personal</td>
                                                                    <td>{{ odsStats.ods5.female_clients_total }}</td>
                                                                    <td>{{ odsStats.ods5.female_count }}</td>
                                                                    <td>{{ mxnFormat(odsStats.ods5.female_total_cost,0) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Empresarial</td>
                                                                    <td>{{ odsStats.ods5.pm_clients_total }}</td>
                                                                    <td>{{ odsStats.ods5.pm_count }}</td>
                                                                    <td>{{ mxnFormat(odsStats.ods5.pm_total_cost,0) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Total</strong></td>
                                                                    <td>{{ odsStats.ods5.female_clients_total + odsStats.ods5.pm_clients_total }}</td>
                                                                    <td>{{ odsStats.ods5.pm_count + odsStats.ods5.female_count }}</td>
                                                                    <td>{{ mxnFormat(odsStats.ods5.pm_total_cost + odsStats.ods5.female_total_cost,0) }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>
                                        </div>
                                    </div>
                                </div>

                                <!-- ODS 6 - blue -->
                                <div v-show="showOds(6)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods10" aria-expanded="true"
                                        aria-controls="ods10" :color="blue" :imgName="'06'" ods="ODS 6"
                                        title="Agua limpia y saneamiento." :capital="mxnFormat(0)" />
                                </div>

                                <!-- ODS 7 - YELLOW -->
                                <div v-show="showOds(7)" class="accordion-item">
                                    <!-- ODS 7 - YELLOW -->
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods1" aria-expanded="false"
                                        aria-controls="ods1" :color="yellow" :imgName="'07'" ods="ODS 7"
                                        title="Energía asequible y no contaminante."
                                        :capital="mxnFormat(getOds7TotalAum)" />
                                    <div id="ods1" class="accordion-collapse collapse show" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <!-- 7.2 PRESTAMO PRODUCTOS - SOLAR FOTOVOLTAICO -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="true"
                                                :icon1="'emisiones'" :icon2="'rayo'" :icon3="'primary'">
                                                <template v-slot:title>
                                                    Meta ODS 7.2 - Energía renovable.
                                                </template>
                                                <template v-slot:description>
                                                    <h4 class="font-weight-100 ">
                                                        De aquí a <span class="bold">2030</span>, aumentar considerablemente
                                                        la proporción de energía renovable en el conjunto de <span
                                                            class="bold">fuentes energéticas</span>.
                                                    </h4>
                                                </template>
                                                <template v-slot:goal>
                                                    Mitigación de emisiones
                                                </template>
                                                <template v-slot:line-action-title>
                                                    <strong>Crédito Ecotecnologías.</strong>
                                                </template>
                                                <template v-slot:line-action>
                                                    <strong>Solar fotovoltáicos.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in productColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(tr, index) in odsStats.ods7.sfv_installed_t">
                                                                    <td>
                                                                        {{ tr.product_name }}
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.product_total,0) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.sum,0) }} kW
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.clients_count,0) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.projects_count,0) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ mxnFormat(tr.total_financed_amount,0) }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>

                                            <!-- 7.2 PRESTAMO PRODUCTOS - SOLAR TERMICO -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="false">
                                                <template v-slot:line-action-title>
                                                    <strong>Crédito Ecotecnologías.</strong>
                                                </template>
                                                <template v-slot:line-action>
                                                    <strong>Solar térmico.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in productColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(tr, index) in odsStats.ods7.sh_installed_t">
                                                                    <td>
                                                                        {{ tr.product_name }}
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.product_total,0) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.sum * 1000,0) }} m2
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.clients_count,0) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.projects_count,0) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ mxnFormat(tr.total_financed_amount,0) }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>

                                            <!-- 7.2 PRESTAMO NEGOCIOS - CADENA DE VALOR SOLAR -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="false">
                                                <template v-slot:line-action-title>
                                                    <strong>Crédito Ecotecnologías.</strong>
                                                </template>
                                                <template v-slot:line-action>
                                                    <strong>Cadena de valor solar.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in businessColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(column, i) in odsStats.ods7.solar_value_chain.projects">
                                                                    <td>{{ column.project_category_theme_name }}</td>
                                                                    <td>{{ column.project_category_theme_type_name || "-" }}</td>
                                                                    <td>{{ generalNumberFormat(column.clients_count, 0) }}</td>
                                                                    <td>{{ generalNumberFormat(column.project_total, 0) }}</td>
                                                                    <td>{{ mxnFormat(column.total_financed_amount,0) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Total</strong></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td>{{ mxnFormat(odsStats.ods7.solar_value_chain.total_amount,0) }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>

                                            <!-- 7.3 PRESTAMO PRODUCTOS - REFRIGERACIÓN -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="true"
                                                :icon1="'emisiones'" :icon2="'rayo'" :icon3="'primary'">
                                                <template v-slot:title>
                                                    Meta ODS 7.3 - Eficiencia energética.
                                                </template>
                                                <template v-slot:description>
                                                    <h4 class="font-weight-100 ">
                                                        De aquí a <span class="bold">2030</span>, duplicar la tasa mundial
                                                        de mejora de la <span class="bold">eficiencia energética</span>.
                                                    </h4>
                                                </template>
                                                <template v-slot:goal>
                                                    Mitigación de emisiones
                                                </template>
                                                <template v-slot:line-action-title>
                                                    <strong>Crédito Ecotecnologías.</strong>
                                                </template>
                                                <template v-slot:line-action>
                                                    <strong>Refrigeración eficiente.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in productColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(tr, index) in odsStats.ods7.refigeration_t">
                                                                    <td>
                                                                        {{ tr.product_name }}
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.product_total,0) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.sum * 1000,0) }} pies cúbicos
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.clients_count,0) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(tr.projects_count,0) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ mxnFormat(tr.total_financed_amount,0) }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>
                                        </div>
                                    </div>
                                </div>

                                <!-- ODS 9 orange -->
                                <div v-show="showOds(9)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods10" aria-expanded="true"
                                        aria-controls="ods09" :color="orange" :imgName="'09'" ods="ODS 9"
                                        title="Industria innovación e infraestructrura." :capital="mxnFormat(0)" />
                                </div>

                                <!-- ODS 10 - pink -->
                                <div v-show="showOds(10)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods10" aria-expanded="true"
                                        aria-controls="ods10" :color="pink" :imgName="'10'" ods="ODS 10"
                                        title="Reducción de las desigualdades." :capital="mxnFormat(0)" />
                                </div>

                                <!-- ODS 8 - pink -->
                                <div v-show="showOds(8)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods08" aria-expanded="true"
                                        aria-controls="ods08" :color="redWine" :imgName="'08'" ods="ODS 8"
                                        title="Trabajo decente y crecimiento económico."
                                        :capital="mxnFormat(getOds8TotalAum)" />

                                    <div id="ods08" class="accordion-collapse collapse show" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <!-- 8.3 -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="true"
                                                :icon1="'resiliencia'" :icon2="null" :icon3="'secondary'">
                                                <template v-slot:title>
                                                    Meta ODS 8.3 – Fortalecimiento empresarial por financiamiento.
                                                </template>
                                                <template v-slot:description>
                                                    <h4 class="font-weight-100">
                                                        Promover políticas orientadas al desarrollo que apoyen las
                                                        actividades
                                                        productivas, la creación de puestos de trabajo decentes,
                                                        el emprendimiento, la creatividad y la innovación, y fomentar
                                                        la formalización y el crecimiento de las microempresas y las
                                                        pequeñas
                                                        y medianas empresas, incluso mediante el acceso a servicios
                                                        financieros.
                                                    </h4>
                                                </template>
                                                <template v-slot:goal>
                                                    Adaptación y resiliencia
                                                </template>
                                                <template v-slot:line-action-title>
                                                    <strong>Ventas concretadas al ofrecer el Crédito Ecotecnologías.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in supplierColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Solar fotovoltáico</td>
                                                                    <td>{{ calculateOds8ProductTotals(odsStats.ods7.sfv_installed_t, "supplier_total") }}</td>
                                                                    <td>{{ calculateOds8ProductTotals(odsStats.ods7.sfv_installed_t, "projects_count") }}</td>
                                                                    <td>{{ mxnFormat(calculateOds8ProductTotals(odsStats.ods7.sfv_installed_t, "pf_total_cost")) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Solar térmico</td>
                                                                    <td>{{ calculateOds8ProductTotals(odsStats.ods7.sh_installed_t, "supplier_total") }}</td>
                                                                    <td>{{ calculateOds8ProductTotals(odsStats.ods7.sh_installed_t, "projects_count") }}</td>
                                                                    <td>{{ mxnFormat(calculateOds8ProductTotals(odsStats.ods7.sh_installed_t, "pf_total_cost")) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Refrigeración eficiente</td>
                                                                    <td>{{ calculateOds8ProductTotals(odsStats.ods7.refigeration_t, "supplier_total") }}</td>
                                                                    <td>{{ calculateOds8ProductTotals(odsStats.ods7.refigeration_t, "projects_count") }}</td>
                                                                    <td>{{ mxnFormat(calculateOds8ProductTotals(odsStats.ods7.refigeration_t, "pf_total_cost")) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Total</strong></td>
                                                                    <td>
                                                                        {{ 
                                                                            calculateOds8ProductTotals(odsStats.ods7.refigeration_t, "supplier_total") 
                                                                            + calculateOds8ProductTotals(odsStats.ods7.sfv_installed_t, "supplier_total")
                                                                            + calculateOds8ProductTotals(odsStats.ods7.sh_installed_t, "supplier_total")
                                                                        }}
                                                                    </td>
                                                                    <td>
                                                                        {{ 
                                                                            calculateOds8ProductTotals(odsStats.ods7.refigeration_t, "projects_count") 
                                                                            + calculateOds8ProductTotals(odsStats.ods7.sfv_installed_t, "projects_count")
                                                                            + calculateOds8ProductTotals(odsStats.ods7.sh_installed_t, "projects_count") 
                                                                        }}
                                                                    </td>
                                                                    <td>
                                                                        {{ 
                                                                            mxnFormat(
                                                                                calculateOds8ProductTotals(odsStats.ods7.refigeration_t, "pf_total_cost")
                                                                                + calculateOds8ProductTotals(odsStats.ods7.sfv_installed_t, "pf_total_cost")
                                                                                + calculateOds8ProductTotals(odsStats.ods7.sh_installed_t, "pf_total_cost") 
                                                                            ) 
                                                                        }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>
                                            <!-- 8.3 -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="false"
                                                :icon1="'resiliencia'" :icon2="null" :icon3="'secondary'">
                                                <template v-slot:goal>
                                                    Adaptación y resiliencia
                                                </template>
                                                <template v-slot:line-action-title>
                                                    <strong>Inclusión financiera empresarial.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in supplierPMColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Persona física con actividad empresarial</td>
                                                                    <td>{{ odsStats.ods8.financial.total_pfae_clients }}</td>
                                                                    <td>{{ odsStats.ods8.financial.total_pfae }}</td>
                                                                    <td>{{ mxnFormat(odsStats.ods8.financial.total_pfae_amount) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Personas morales</td>
                                                                    <td>{{ odsStats.ods8.financial.total_pm_clients }}</td>
                                                                    <td>{{ odsStats.ods8.financial.total_pm }}</td>
                                                                    <td>{{ mxnFormat(odsStats.ods8.financial.total_pm_amount) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Total</strong></td>
                                                                    <td>{{ odsStats.ods8.financial.total_pfae_clients + odsStats.ods8.financial.total_pm_clients }}</td>
                                                                    <td>{{ odsStats.ods8.financial.total_pm + odsStats.ods8.financial.total_pfae }}</td>
                                                                    <td>{{ mxnFormat(odsStats.ods8.financial.total_pm_amount + odsStats.ods8.financial.total_pfae_amount) }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>
                                        </div>
                                    </div>
                                </div>

                                <!-- ODS 11 - orange -->
                                <div v-show="showOds(11)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods11" aria-expanded="true"
                                        aria-controls="ods11" :color="orange11" :imgName="'11'" ods="ODS 11"
                                        title="Ciudades y comunidades sostenibles." :capital="mxnFormat(getOds11TotalAum)" />
                                    <div id="ods11" class="accordion-collapse collapse show" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <!-- 7.2 PRESTAMO PRODUCTOS -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="true"
                                                :icon1="'emisiones'" :icon2="'construccion'" :icon3="'primary'">
                                                <template v-slot:title>
                                                    Meta ODS 11.c – Edificios sostenibles
                                                </template>
                                                <template v-slot:description>
                                                    <h4 class="font-weight-100 ">
                                                        Proporcionar apoyo a los países menos adelantados,
                                                        incluso mediante asistencia financiera y técnica,
                                                        para que puedan construir edificios sostenibles y resilientes
                                                        utilizando materiales locales.
                                                    </h4>
                                                </template>
                                                <template v-slot:goal>
                                                    Mitigación de emisiones
                                                </template>
                                                <template v-slot:line-action-title>
                                                    <strong>Crédito PYME.</strong>
                                                </template>
                                                <template v-slot:line-action>
                                                    <strong>Producción de materiales.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in businessColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(column, i) in odsStats.ods11.buildings.projects">
                                                                    <td>{{ column.project_category_theme_name }}</td>
                                                                    <td>{{ column.project_category_theme_type_name || "-" }}</td>
                                                                    <td>{{ column.clients_count }}</td>
                                                                    <td>{{ column.project_total }}</td>
                                                                    <td>{{ mxnFormat(column.total_financed_amount,0) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Total</strong></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td>{{ mxnFormat(odsStats.ods11.buildings.total_amount,0) }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>
                                        </div>
                                    </div>
                                </div>

                                <!-- ODS 12 - YELLOW -->
                                <div v-show="showOds(12)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods12" aria-expanded="true"
                                        aria-controls="ods12" :color="yellow12" :imgName="'12'" ods="ODS 12"
                                        title="Producción y consumo responsables." :capital="mxnFormat(getOds12TotalAum)" />
                                    <div id="ods12" class="accordion-collapse collapse show" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <!-- 7.2 PRESTAMO PRODUCTOS -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="true"
                                                :icon1="'emisiones'" :icon2="'3r'" :icon3="'primary'">
                                                <template v-slot:title>
                                                    Meta ODS 12.5 – Reducción de generación de desechos (3Rs)
                                                </template>
                                                <template v-slot:description>
                                                    <h4 class="font-weight-100 ">
                                                        De aquí a 2030, reducir considerablemente la generación
                                                        de desechos mediante actividades de prevención, reducción,
                                                        reciclado y reutilización.
                                                    </h4>
                                                </template>
                                                <template v-slot:goal>
                                                    Mitigación de emisiones
                                                </template>
                                                <template v-slot:line-action-title>
                                                    <strong>Crédito PYME.</strong>
                                                </template>
                                                <template v-slot:line-action>
                                                    <strong>Reuso.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in businessColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(column, i) in odsStats.ods12.reuse.projects">
                                                                    <td>{{ column.project_category_theme_name }}</td>
                                                                    <td>{{ column.project_category_theme_type_name || "-" }}</td>
                                                                    <td>{{ column.clients_count }}</td>
                                                                    <td>{{ column.project_total }}</td>
                                                                    <td>{{ mxnFormat(column.total_financed_amount,0) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Total</strong></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td>{{ mxnFormat(odsStats.ods12.reuse.total_amount,0) }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>

                                            <!-- 7.2 PRESTAMO PRODUCTOS -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="false">
                                                <template v-slot:line-action-title>
                                                    <strong>Crédito PYME.</strong>
                                                </template>
                                                <template v-slot:line-action>
                                                    <strong>Reciclaje.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in businessColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(column, i) in odsStats.ods12.recycling.projects">
                                                                    <td>{{ column.project_category_theme_name }}</td>
                                                                    <td>{{ column.project_category_theme_type_name || "-" }}</td>
                                                                    <td>{{ column.clients_count }}</td>
                                                                    <td>{{ column.project_total }}</td>
                                                                    <td>{{ mxnFormat(column.total_financed_amount,0) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Total</strong></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td>{{ mxnFormat(odsStats.ods12.recycling.total_amount,0) }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>
                                        </div>
                                    </div>
                                </div>

                                <!-- ODS 13 - GREEN -->
                                <div v-show="showOds(13)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods13" aria-expanded="true"
                                        aria-controls="ods1" :color="green13" :imgName="'13'" ods="ODS 13"
                                        title="Acción por el clima" :capital="mxnFormat(isMounted ? odsStats.ods13.projects_data.profile.amount_total : 0)" />
                                    <div v-if="isMounted" id="ods13" class="accordion-collapse collapse show" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <div class="row">
                                                <!-- 17.17 -->
                                                <div class="col-12">
                                                    <div class="section-heading heading-left mb--20 mb_md--70">
                                                        <span class="subtitle primary">
                                                            Meta ODS 13.3 – Capacidades para combatir el cambio climático
                                                        </span>
                                                        <h4 class="font-weight-100 ">
                                                            Mejorar la educación, la sensibilización y la capacidad humana
                                                            e institucional respecto de la <span
                                                                class="bold">mitigación</span> del cambio climático,
                                                            la <span class="bold">adaptación</span> a él, la reducción de
                                                            sus efectos y la alerta temprana.
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div class="col-sm-12 col-md-10 col-lg-10">
                                                    <label for="select13" class="bold mb-2">¿Qué te gustaría
                                                        visualizar?</label>
                                                    <!-- <select v-model.lazy="optionSelected" name="select13" placeholder="Tipo de créditos"
                                                        class="form-control picker shadow">
                                                        <option v-for="item in selectOptions" :value="item.value"
                                                            v-bind:key="item.value">{{ item.text }}</option>
                                                    </select> -->

                                                    <div class="row mt-4">
                                                        <div v-for="(btn, index) in selectOptions" class="col-sm-12 col-md-3 col-lg-3 mb-3">
                                                            <button @click.stop="optionSelected = btn.value"
                                                                class="btn btn-outline-black bold p-3"
                                                                :class="optionSelected == btn.value ? 'black-active-btn' : ''">{{ btn.text }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div id="options" class="row mt-4">
                                                        <div class="col-sm-6 col-md-3 col-lg-2 mb-3">
                                                            <button @click.stop="selected = 0"
                                                                class="btn btn-outline-primary p-3 bold"
                                                                :class="selected == 0 ? 'active-btn' : ''">Perfil</button>
                                                        </div>
                                                        <div class="col-sm-6 col-md-3 col-lg-2 mb-3">
                                                            <button @click.stop="selected = 3"
                                                                class="btn btn-outline-primary p-3 bold"
                                                                :class="selected == 3 ? 'active-btn' : ''">Edad</button>
                                                        </div>
                                                        <!-- <div class="col-sm-6 col-md-3 col-lg-2 mb-3">
                                                            <button @click.stop="selected = 2"
                                                                class="btn btn-outline-primary p-3 bold"
                                                                :class="selected == 2 ? 'active-btn' : ''">Portafolio</button>
                                                        </div> -->
                                                        <div class="col-sm-6 col-md-3 col-lg-2 mb-3">
                                                            <button @click.stop="selected = 1"
                                                                class="btn btn-outline-primary p-3 bold"
                                                                :class="selected == 1 ? 'active-btn' : ''">Ubicación</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row text-align-center">
                                                <!-- PROFILE -->
                                                <template v-if="selected == 0">
                                                    <div id="chart_A" class="col-sm-12 col-md-12 col-lg-5">
                                                        <VueApexCharts v-if="isGraphReady" type="pie" width="480"
                                                            :options="chartOptionsA" :series="getProfileSeries">
                                                        </VueApexCharts>
                                                    </div>
                                                    <div class="col-sm-12 col-md-12 col-lg-6 mt-4">
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <h1 class="bold mb-0 primary">
                                                                    {{ calculatePercentage(getSourceData.profile,
                                                                        "total_m") }}%
                                                                </h1>
                                                                <h6 class="bold data-card primary-card">Hombres</h6>
                                                            </div>
                                                            <div class="col-6">
                                                                <h1 class="bold mb-0 accent1">
                                                                    {{ calculatePercentage(getSourceData.profile,
                                                                        "total_f") }}%
                                                                </h1>
                                                                <h6 class="bold data-card accent1-card">Mujeres</h6>
                                                            </div>
                                                            <div class="col-6">
                                                                <h1 class="bold mb-0 gray">
                                                                    {{ calculatePercentage(getSourceData.profile,
                                                                        "total_pm") }}%
                                                                </h1>
                                                                <h6 class="bold data-card gray-card">Personas Morales</h6>
                                                            </div>
                                                            <!-- <div class="col-6">
                                                            <h1 class="bold mb-0 black">
                                                                {{ percentageA[3].toFixed(0) }}%
                                                            </h1>
                                                            <h6 class="bold data-card black-card">Vencido (+90 días): {{ explicitMoneyFormat(seriesA[3], 0) }}</h6>
                                                        </div> -->
                                                        </div>
                                                    </div>
                                                </template>
                                                <!-- AGE -->
                                                <template v-if="selected == 3">
                                                    <div id="chart_A" class="col-sm-12 col-md-12 col-lg-5">
                                                        <VueApexCharts v-if="isGraphReady" type="pie" width="480"
                                                            :options="chartOptionsA" :series="getAgeSeries"></VueApexCharts>
                                                    </div>
                                                    <div class="col-sm-12 col-md-12 col-lg-6 mt-4">
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <h1 class="bold mb-0 primary">
                                                                    {{ calculatePercentage(getSourceData.age,
                                                                        "total_18_25") }}%
                                                                </h1>
                                                                <h6 class="bold data-card primary-card">18 a 25 años</h6>
                                                            </div>
                                                            <div class="col-6">
                                                                <h1 class="bold mb-0 accent1">
                                                                    {{ calculatePercentage(getSourceData.age,
                                                                        "total_26_35") }}%
                                                                </h1>
                                                                <h6 class="bold data-card accent1-card">25 a 35 años</h6>
                                                            </div>
                                                            <div class="col-6">
                                                                <h1 class="bold mb-0 gray">
                                                                    {{ calculatePercentage(getSourceData.age,
                                                                        "total_36_50") }}%
                                                                </h1>
                                                                <h6 class="bold data-card gray-card">35 a 50 años</h6>
                                                            </div>
                                                            <div class="col-6">
                                                                <h1 class="bold mb-0 black">
                                                                    {{ calculatePercentage(getSourceData.age,
                                                                        "total_over_50") }}%
                                                                </h1>
                                                                <h6 class="bold data-card black-card">50 años o más</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <!-- PORTFOLIO -->
                                                <template v-if="selected == 2">
                                                    <div id="chart_A" class="col-sm-12 col-md-12 col-lg-5">
                                                        <VueApexCharts v-if="isGraphReady" type="pie" width="480"
                                                            :options="chartOptionsA" :series="getPortfolioSeries">
                                                        </VueApexCharts>
                                                    </div>
                                                    <div class="col-sm-12 col-md-12 col-lg-6 mt-4">
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <h1 class="bold mb-0 primary">
                                                                    {{
                                                                        calculatePercentage(getSourceData.invested_portfolio,
                                                                            "total_1_to_10000") }}%
                                                                </h1>
                                                                <h6 class="bold data-card primary-card">$1 a $10,000
                                                                    invertidos</h6>
                                                            </div>
                                                            <div class="col-6">
                                                                <h1 class="bold mb-0 accent1">
                                                                    {{
                                                                        calculatePercentage(getSourceData.invested_portfolio,
                                                                            "total_over_250000") }}%
                                                                </h1>
                                                                <h6 class="bold data-card accent1-card">$10,000 a $50,000
                                                                    invertidos</h6>
                                                            </div>
                                                            <div class="col-6">
                                                                <h1 class="bold mb-0 gray">
                                                                    {{
                                                                        calculatePercentage(getSourceData.invested_portfolio,
                                                                            "total_10001_to_50000") }}%
                                                                </h1>
                                                                <h6 class="bold data-card gray-card">$50,000 a $250,000
                                                                    invertidos</h6>
                                                            </div>
                                                            <div class="col-6">
                                                                <h1 class="bold mb-0 black">
                                                                    {{
                                                                        calculatePercentage(getSourceData.invested_portfolio,
                                                                            "total_50001_to_250000") }}%
                                                                </h1>
                                                                <h6 class="bold data-card black-card">$250,000 o más
                                                                    invertidos</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <!-- UBICACIÓN -->
                                                <template v-show="showMap">
                                                    <div id="chart_A" class="col-sm-8 col-md-8 col-lg-10">
                                                        <div  v-show="showMap" id="container"></div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- ODS 15 - GREEN -->
                                <div v-show="showOds(15)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods15" aria-expanded="true"
                                        aria-controls="ods15" :color="green" :imgName="'15'" ods="ODS 15"
                                        title="Vida de ecosistemas terrestres." :capital="mxnFormat(getOds15TotalAum)" />
                                    <div id="ods15" class="accordion-collapse collapse show" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <!-- 7.2 PRESTAMO PRODUCTOS -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="true"
                                                :icon1="'emisiones'" :icon2="'agronegocios'" :icon3="'primary'">
                                                <template v-slot:title>
                                                    Meta ODS 15.3 – Degradación neutra del suelo.
                                                </template>
                                                <template v-slot:description>
                                                    <h4 class="font-weight-100 ">
                                                        Para 2030, luchar contra la desertificación, rehabilitar las tierras
                                                        y los suelos degradados, incluidas las tierras afectadas
                                                        por la desertificación, la sequía y las inundaciones,
                                                        y procurar lograr un mundo con una degradación neutra del suelo.
                                                    </h4>
                                                </template>
                                                <template v-slot:goal>
                                                    Mitigación de emisiones
                                                </template>
                                                <template v-slot:line-action-title>
                                                    <strong>Crédito PYME.</strong>
                                                </template>
                                                <template v-slot:line-action>
                                                    <strong>Agricultura.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in businessColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(column, i) in odsStats.ods15.agriculture.projects">
                                                                    <td>{{ column.project_category_theme_name }}</td>
                                                                    <td>{{ column.project_category_theme_type_name || "-" }}</td>
                                                                    <td>{{ column.clients_count }}</td>
                                                                    <td>{{ column.project_total }}</td>
                                                                    <td>{{ mxnFormat(column.total_financed_amount,0) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Total</strong></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td>{{ mxnFormat(odsStats.ods15.agriculture.total_amount,0) }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>

                                            <!-- 7.2 PRESTAMO PRODUCTOS -->
                                            <ods-details v-if="isMounted" :needChart="false" :needIcon="false">
                                                <template v-slot:line-action-title>
                                                    <strong>Crédito PYME.</strong>
                                                </template>
                                                <template v-slot:line-action>
                                                    <strong>Apicultura.</strong>
                                                </template>
                                                <template v-slot:body>
                                                    <div class="table-responsive-sm w-75 sm-width-auto">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in businessColumns"
                                                                        scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(column, i) in odsStats.ods15.beekeeping.projects">
                                                                    <td>{{ column.project_category_theme_name }}</td>
                                                                    <td>{{ column.project_category_theme_type_name || "-" }}</td>
                                                                    <td>{{ column.clients_count }}</td>
                                                                    <td>{{ column.project_total }}</td>
                                                                    <td>{{ mxnFormat(column.total_financed_amount,0) }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Total</strong></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td>{{ mxnFormat(odsStats.ods15.beekeeping.total_amount,0) }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </ods-details>
                                        </div>
                                    </div>
                                </div>

                                <!-- ODS 17 - BLUE -->
                                <div v-show="showOds(17)" class="accordion-item">
                                    <ods-card data-bs-toggle="collapse" data-bs-target="#ods17" aria-expanded="true"
                                        aria-controls="ods17" :color="blue" :imgName="'17'" ods="ODS 17"
                                        title="Alianzas para lograr los objetivos."
                                        :capital="mxnFormat(getOds17TotalAum)" />
                                    <div v-if="isMounted" id="ods17" class="accordion-collapse collapse show" data-bs-parent="#accordion">
                                        <div class="accordion-body">
                                            <div class="row">
                                                <!-- 17.17 -->
                                                <div class="col-12">
                                                    <div class="section-heading heading-left mb--20 mb_md--70">
                                                        <span class="subtitle primary">
                                                            Meta ODS 17.17 – Alianzas públicas y/o privadas
                                                        </span>
                                                        <h4 class="font-weight-100 ">
                                                            Fomentar y promover la constitución de <span
                                                                class="bold">alianzas eficaces</span> en las
                                                            esferas pública, público-privada y de la sociedad civil,
                                                            aprovechando la experiencia y las estrategias de obtención de
                                                            recursos de las alianzas.
                                                        </h4>
                                                    </div>

                                                    <div class="table-responsive-sm">
                                                        <table class="table rg-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(column, index) in columns" scope="col"
                                                                        :class="column.bold ? 'bold' : 'normal'">{{
                                                                            column.title }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <router-link :to="{name: 'emerge'}">{{ getProgramName("EMERGE") }}</router-link>
                                                                    </td>
                                                                    <td>
                                                                        {{ getProgramDescription("EMERGE") }}
                                                                    </td>
                                                                    <td> {{ this.odsStats.ods17.KOF.clients_count }} </td>
                                                                    <td> {{ this.odsStats.ods17.KOF.total }} </td>
                                                                    <td> {{ mxnFormat(this.odsStats.ods17.KOF.total_cost) }} </td>
                                                                </tr>
                                                                <tr v-for="(tr, index) in this.odsStats.ods17.programs">
                                                                    <td>
                                                                        {{ getProgramName(tr.business_alliance) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ getProgramDescription(tr.business_alliance) }}
                                                                    </td>
                                                                    <td>
                                                                       {{ (tr.clients_count) }}
                                                                    </td>
                                                                    <td>
                                                                       {{ (tr.program_count) }}
                                                                    </td>
                                                                    <td>
                                                                       {{ mxnFormat(tr.program_total_cost) }}
                                                                    </td>
                                                                </tr>                                                  <tr>
                                                                    <td><strong>Total</strong></td>
                                                                    <td>

                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(getOds17TotalClients, 0) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ generalNumberFormat(getOds17TotalProjects, 0) }}
                                                                    </td>
                                                                    <td>
                                                                        {{ mxnFormat(getOds17TotalAum) }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- EN ESTE APARTADO VA EL TEMA DE LOS ODS QUE CAMBIAN CON LA SELECCIÓN DE LA GRÁFICA -->
            </div>
        </section>
    </div>
</template>

<script>
import odsCard from '../partials/ods-card.vue';
import odsDetails from '../partials/ods-details.vue';
import formatHelpers from "@mixins/formatHelper.js";
import VueApexCharts from 'vue-apexcharts';

const columns = [
    { title: "Programa", bold: true },
    { title: "Participantes", bold: false },
    { title: "Solicitantes", bold: false },
    { title: "Créditos", bold: false },
    { title: "Monto", bold: false }
];
const productColumns = [
    { title: "Productos", bold: true },
    { title: "Cantidad", bold: false },
    { title: "Capacidad total", bold: false },
    { title: "Solicitantes", bold: false },
    { title: "Créditos", bold: false },
    { title: "Monto", bold: false }
];
const businessColumns = [
    { title: "Giro", bold: true },
    { title: "Tipo", bold: false },
    { title: "Solicitantes", bold: false },
    { title: "Créditos", bold: false },
    { title: "Monto", bold: false }
];
const generalColumns = [
    { title: "Crédito", bold: true },
    { title: "Solicitantes", bold: false },
    { title: "Créditos", bold: false },
    { title: "Monto", bold: false }
];
const supplierColumns = [
    { title: "Producto", bold: true },
    { title: "Proveedores", bold: false },
    { title: "Clientes", bold: false },
    { title: "Ventas", bold: false }
];
const supplierPMColumns = [
    { title: "Giro", bold: true },
    { title: "Solicitantes", bold: false },
    { title: "Créditos", bold: false },
    { title: "Monto", bold: false }
];

export default {
    name: "PrimaryImpact",
    props: ["odsStats", "isMounted"],
    mixins: [formatHelpers],
    components: {
        odsCard,
        odsDetails,
        VueApexCharts
    },
    data() {
        return {
            yellow: "#febf04",
            green: "#59ba47",
            red: "#fe2707",
            pink: "#ff015b",
            orange: "#ff5104",
            blue: "#0b81e9",
            green13: "#507e4c",
            yellow12: "#ffa800",
            orange11: "#ffaf4c",
            yellow2: "#ffb112",
            redWine: "#952a45",
            redOds04: "#c7212f",
            redOds01: "#e5233d",
            green03: "#4ca146",
            liveData: null,
            columns: columns,
            productColumns: productColumns,
            businessColumns: businessColumns,
            generalColumns: generalColumns,
            supplierColumns: supplierColumns,
            supplierPMColumns: supplierPMColumns,
            selectOptions: [
                { value: 1, text: "Inversionistas (#)" },
                { value: 2, text: "Inversionistas ($)" },
                { value: 3, text: "Créditos (#)" },
                { value: 4, text: "Créditos ($)" }
            ],
            optionSelected: 1,
            selected: 0,
            // gráficas
            topology: null,
            isGraphReady: true,
            percentageA: [0, 0, 0, 0],
            seriesA: [0, 0, 0, 0],
            chartOptionsA: {
                chart: {
                    width: 380,
                    type: 'pie',
                },
                dataLabels: {
                    enabled: false,
                },
                tooltip: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                colors: ["#28DE18", "#CBFF00", "#999EAC", "#3B3A3E"],
                labels: ['Team A', 'Team B', 'Team C', 'Team D'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            show: false
                        },
                    }
                }]
            },

            chartOptionsHeatMap: {
                legend: {
                    show: false
                },
                colors: ["#28DE18", "#CBFF00", "#999EAC", "#3B3A3E"],
                chart: {
                    height: 480,
                    type: 'treemap'
                },
                title: {
                    text: ''
                }
            },
            minValue: 0,
            maxValue: 0,
            targetId: 12,
            series: [
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
            ],
            chartOptions:
            {
                "chart": {
                    width: '750',
                    height: '450',
                    responsive: [{
                        breakpoint: 320,
                        options: {
                            chart: {
                                width: 350
                            },
                            legend: {
                                show: true
                            },
                        }
                    }],
                    "animations": {
                        "enabled": false
                    },
                    "background": "#fff",
                    "id": "1iaCw",
                    "toolbar": {
                        "show": false
                    },
                    "type": "donut",
                    events: {
                        click: (event, chartContext, config) => {
                            // console.log(event.target.attributes[10].value);
                            this.targetId = event.target.attributes[10].value;
                        }
                    },
                },
                "plotOptions": {
                    "bar": {
                        "borderRadius": 10,
                        "borderRadiusApplication": "end",
                        "borderRadiusWhenStacked": "last",
                        "hideZeroBarsWhenGrouped": false,
                        "isDumbbell": false,
                        "isFunnel": false,
                        "isFunnel3d": false,
                        "dataLabels": {
                            "total": {
                                "enabled": false,
                                "offsetX": 0,
                                "offsetY": 0,
                                "style": {
                                    "color": "#373d3f",
                                    "fontSize": "12px",
                                    "fontWeight": 600
                                }
                            }
                        }
                    },
                    "bubble": {
                        "zScaling": false
                    },
                    "treemap": {
                        "dataLabels": {
                            "format": "scale"
                        }
                    },
                    "radialBar": {
                        "hollow": {
                            "background": "#fff"
                        },
                        "dataLabels": {
                            "name": {},
                            "value": {},
                            "total": {}
                        }
                    },
                    "pie": {
                        "donut": {
                            "size": "50%",
                            "labels": {
                                enabled: false,
                                "name": {},
                                "value": {},
                                "total": {}
                            }
                        }
                    }
                },
                "colors": [
                    "#e52f45",
                    "#ddaa3f",
                    "#50a03c",
                    "#c61f33",
                    "#fe4028",
                    "#2bbee2",
                    "#fbc411",
                    "#a41f47",
                    "#fc6e2d",
                    "#dd196a",
                    "#fc9f29",
                    "#c08e34",
                    "#448149",
                    "#0fa3dc",
                    "#5bc132",
                    "#066b9f",
                    "#204e6f",
                    "#f1f2f3"
                ],
                "dataLabels": {
                    "enabled": false,
                    "style": {
                        "fontWeight": 700
                    }
                },
                "fill": {
                    "opacity": 1
                },
                "grid": {
                    "padding": {
                        "right": 0,
                        "bottom": 12,
                        "left": 10
                    }
                },
                "labels": [
                    "Fin de la probreza",
                    "Hambre cero",
                    "Salud y bienestar",
                    "Educación de calidad",
                    "Igualdad de género",
                    "Agua limpia y saneamiento",
                    "Energía asequible y no contaminante",
                    "Trabajo decente y crecimiento económico",
                    "Industria, innovación e infraestructura",
                    "Reducción de las desigualdades",
                    "Ciudades y comunidades sostenibles",
                    "Producción y consumo responsables",
                    "Acción por el clima",
                    "Vida submarina",
                    "Vida de ecosistemas terrestres",
                    "Paz, justicia e instituciones sólidas",
                    "Alianzas para lograr los objetivos",
                ],
                "legend": {
                    "show": false,
                },
                "stroke": {
                    "width": 10,
                    "colors": [
                        "#fff"
                    ],
                    "fill": {
                        "type": "solid",
                        "opacity": 0,
                  
                    }
                },
                "tooltip": {
                    "fillSeriesColor": false,
                    enabled: true,
                },
                "xaxis": {
                    "labels": {
                        "trim": true,
                        "style": {}
                    },
                    "group": {
                        "groups": [],
                        "style": {
                            "colors": [],
                            "fontSize": "12px",
                            "fontWeight": 400,
                            "cssClass": ""
                        }
                    },
                    "title": {
                        "style": {
                            "fontWeight": 700
                        }
                    }
                },
                "yaxis": {
                    "labels": {
                        "style": {},
                        formatter: function (val) {
                            let value = (val / 1).toFixed(0).replace(",", ".");
                            let money = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            if (money == null) return "";
                            else {
                                return "$" + money
                            }
                        }
                    },
                    "title": {
                        "style": {
                            "fontWeight": 700
                        }
                    }
                },
            },
            isCreated: false
        }
    },
    async created() {
        this.isCreated = false;
        await this.addLibraries();
        this.topology = await fetch(
            'https://code.highcharts.com/mapdata/countries/mx/mx-all.topo.json'
            ).then(response => response.json());
        this.buildOdsMenu();
        this.isCreated = true;
    },
    async beforeMount() {
        // await this.getOdsStats();
    },
    watch: {
        selected: function (val) {
            if (val == 1) {
                this.buildMap();
            }
        },
        optionSelected: function (val) {
            if (this.selected == 1) {
                this.buildMap();
            }
        }
    },
    computed: {
        getTotalAum() {
            if (this.isMounted) {
                return (this.odsStats.ods7.sfV_installed_m
                    + this.odsStats.ods7.sh_installed_m
                    + this.odsStats.ods7.refigeration_m
                    + this.odsStats.ods5.female_total_cost
                    + this.odsStats.ods17.program_total_cost).toFixed(0)
            } else {
                return 0;
            }
        },
        getOds7TotalAum() {
            if (this.isMounted) {
                return (this.odsStats.ods7.sfV_installed_m
                    + this.odsStats.ods7.sh_installed_m
                    + this.odsStats.ods7.refigeration_m
                    + this.odsStats.ods7.solar_value_chain.total_amount
                    ).toFixed(0)
            } else {
                return 0;
            }
        },
        getOds5TotalAum() {
            if (this.isMounted) {
                return (this.odsStats.ods5.female_total_cost + this.odsStats.ods5.pm_total_cost).toFixed(0)
            } else {
                return 0;
            }
        },
        getOds17TotalAum() {
            if (this.isMounted) {
                const data = this.odsStats.ods17.programs;
                let total = 0;
                data.forEach(element => {
                    total += element.program_total_cost;
                });
                return (total + this.odsStats.ods17.KOF.total_cost).toFixed(0);
            } else {
                return 0;
            }
        },
        getOds8TotalAum() {
            if (this.isMounted) {
                return (this.calculateOds8ProductTotals(this.odsStats.ods7.refigeration_t, "pf_total_cost")
                + this.calculateOds8ProductTotals(this.odsStats.ods7.sfv_installed_t, "pf_total_cost")
                + this.calculateOds8ProductTotals(this.odsStats.ods7.sh_installed_t, "pf_total_cost") 
                + this.odsStats.ods8.financial.total_pm_amount 
                + this.odsStats.ods8.financial.total_pfae_amount)
            }

            return 0;
            
        },
        getOds11TotalAum(){
            if (this.isMounted) {
                return (this.odsStats.ods11.buildings.total_amount).toFixed(0)
            }

            return 0;
        },
        getOds12TotalAum(){
            if (this.isMounted) {
                return (this.odsStats.ods12.reuse.total_amount).toFixed(0)
            }

            return 0;
        },
        getOds13TotalAum() {
            if(this.isMounted) {
                return (this.odsStats.ods13.projects_data.profile.amount_total).toFixed(0);
            } else {
                return 0;
            }
        },
        getOds15TotalAum(){
            if (this.isMounted) {
                return (this.odsStats.ods15.beekeeping.total_amount
                        + this.odsStats.ods15.agriculture.total_amount).toFixed(0)
            }

            return 0;
        },
        getOds17TotalProjects() {
            if (this.isMounted) {
                const data = this.odsStats.ods17.programs;
                let total = 0;
                data.forEach(element => {
                    total += element.program_count;
                });
                return (total + this.odsStats.ods17.KOF.total).toFixed(0);
            } else {
                return 0;
            }
        },
        getOds17TotalClients() {
            if (this.isMounted) {
                const data = this.odsStats.ods17.programs;
                let total = 0;
                data.forEach(element => {
                    total += element.clients_count;
                });
                return (total + this.odsStats.ods17.KOF.clients_count).toFixed(0);
            } else {
                return 0;
            }
        },
        getSourceData() {
            if (this.isMounted) {
                if(this.optionSelected == 1 || this.optionSelected == 2) {
                    return this.odsStats.ods13.investors_data;
                } else {
                    return this.odsStats.ods13.projects_data;
                }
            }

            return null;
        },
        getProfileSeries() {
            if (this.isMounted) {
                let profileData = this.getSourceData.profile;
                let data = [];
                // Inversion en persona
                if(this.optionSelected == 1 || this.optionSelected == 3) {
                    data = [profileData.total_m, profileData.total_f, profileData.total_pm];
                } else if (this.optionSelected == 2 || this.optionSelected == 4) {
                    data = [profileData.amount_total_m, profileData.amount_total_f, profileData.amount_total_pm];
                }
                return data;
            } else {
                return [];
            }
        },
        getAgeSeries() {
            if (this.isMounted) {
                let ageData = this.getSourceData.age;
                let data = [];
                if(this.optionSelected == 1 || this.optionSelected == 3) {
                    data = [ageData.total_18_25, ageData.total_26_35, ageData.total_36_50, ageData.total_over_50];
                } else if(this.optionSelected == 2 || this.optionSelected == 4) {
                    data = [ageData.amount_total_18_25, ageData.amount_total_26_35, ageData.amount_total_36_50, ageData.amount_total_over_50];
                }
                return data;
            } else {
                return [];
            }
        },
        getPortfolioSeries() {
            if (this.isMounted) {
                let investedData = this.getSourceData.invested_portfolio;
                let data = [];
                // Inversion en persona
                if(this.optionSelected == 1 || this.optionSelected == 3) {
                    data = [investedData.total_1_to_10000, investedData.total_10001_to_50000, investedData.total_50001_to_250000, investedData.total_over_250000];
                } else if (this.optionSelected == 2 || this.optionSelected == 4) {
                    // Inversión en dinero
                    data = [investedData.amount_total_1_to_10000, investedData.amount_total_10001_to_50000, investedData.amount_total_50001_to_250000, investedData.amount_total_over_250000];
                }

                return data;
            } else {
                return [];
            }
        },
        getHeatMapSeries() {
            if (this.isMounted) {
                let statesData = this.getSourceData.states;
                let data = [];
                let valueIndex = 1
                if(this.optionSelected == 2 || this.optionSelected == 4) {
                    valueIndex = 3;
                }
                let values = [];
                statesData.forEach(item => {
                    if(this.optionSelected == 2 || this.optionSelected == 4) { 
                        data.push([item[0], item[valueIndex]]);
                    } else {
                        data.push([item[0], item[valueIndex]]);
                    }
                    values.push(item[valueIndex]);
                });
                this.minValue = Math.min(...values);
                this.maxValue = Math.max(...values);

                return data;
            }
            return data;
        },
        showMap() {
            return this.selected == 1;
        },
    },
    methods: {
        calculatePercentage(serie, category) {
            let amounString = "";
            if (this.optionSelected == 2 || this.optionSelected == 4) {
                amounString = "amount_";
            }
            const total = serie[`${amounString}total`] == 0 ? 1 : serie[`${amounString}total`];

            let value = serie[amounString + category];

            return ((value * 100) / total).toFixed(1);

        },
        getProgramName(program) {
            const programName = {
                "EMERGE" : "Emerge",
                "EPS" : "Emprendimientos en paisajes sostenibles",
                "BYD": "Vehículos eléctricos"
            };

            return programName[program] || "NA";
        },
        getProgramDescription(program) {
            const programDescription = {
                "EMERGE" : "Coca–Cola FEMSA (IP) \n GIZ (Cooperación Internacional)",
                "EPS" : "SVX (IP) \n Conservación Internacional (ONG)",
                "BYD" : "BYD"
            };

            return programDescription[program] || "NA";
        }, 
        calculateOds8ProductTotals(technologies, category) {
            let total = 0;
            technologies.forEach(technology => {
                total += technology[category];
            });

            return total;
        },
        async addLibraries() {
            let externalScript = document.createElement('script');
            externalScript.setAttribute('src','https://code.highcharts.com/maps/highmaps.js');
            document.head.appendChild(externalScript);
            let externalScript2 = document.createElement('script');
            externalScript2.setAttribute('src','https://code.highcharts.com/maps/modules/exporting.js');
            document.head.appendChild(externalScript2);
        },
        buildMap() {
            const data = this.getHeatMapSeries;
            const topology = this.topology;
            const min = this.minValue;
            const max = this.maxValue;
            const isMoney = this.optionSelected == 2 || this.optionSelected == 4;
            // Create the chart
            Highcharts.mapChart('container', {
                chart: {
                    map: topology
                },
                title: {
                    text: 'República Mexicana'
                },

                subtitle: {
                    text: 'Mapa interactivo'
                },

                mapNavigation: {
                    enabled: true,
                    buttonOptions: {
                        verticalAlign: 'bottom'
                    }
                },

                colorAxis: {
                    min: min,
                    max: max,
                    minColor: '#FFF',
                    maxColor: '#28DE18'
                },
                series: [{
                    data: data,
                    name: 'Total',
                    states: {
                        hover: {
                            color: '#CBFF00',
                        },
                    },
                    tooltip: {
                        pointFormatter: function() {
                            if(isMoney) {
                                return '$'+ Highcharts.numberFormat(this.value, 2);
                            } else {
                                return this.value;
                            }
                        },
                    },
                    
                    dataLabels: {
                        enabled: true,
                        format: '{point.name}',
                    }
                }]
            });
        },
        showOds(odsToShow) {
            return (parseInt(this.targetId) + 1) == odsToShow;
        },
        buildOdsMenu() {
            this.series = [
                0,                                  // ods - 1
                0,                                  // ods - 2
                0,                                  // ods - 3
                0,                                  // ods - 4
                parseInt(this.getOds5TotalAum),     // ods - 5
                0,                                  // ods - 6
                parseInt(this.getOds7TotalAum),     // ods - 7
                parseInt(this.getOds8TotalAum),     // ods - 8
                0,                                  // ods - 9
                0,                                  // ods - 10
                parseInt(this.getOds11TotalAum),    // ods - 11
                parseInt(this.getOds12TotalAum),    // ods - 12
                parseInt(this.getOds13TotalAum),    // ods - 13
                0,                                  // ods - 14
                parseInt(this.getOds15TotalAum),    // ods - 15
                0,                                  // ods - 16
                parseInt(this.getOds17TotalAum)     // ods - 17
            ];
        }
    }
}
</script>

<style>.accordion-item {
    border-radius: 50px !important;
}

.btn-outline-primary {
    border-radius: 20px;
    width: 85%;
}

.active-btn {
    background-color: var(--color-primary);
    color: var(--color-white);
    border-color: var(--color-primary);
}
.black-active-btn {
    background-color: var(--color-black);
    color: var(--color-white);
    border-color: var(--color-black);
}

#chart_A {
    text-align: -webkit-center;
}
#container {
    height: 500px;
    min-width: 310px;
    max-width: 800px;
    margin: 0 auto;
}

.banner-style-5 {
    padding: 200px 40px 0;
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/banners/banner-impacto.png") !important;
}

.banner.banner-style-5::after {
    background-color: transparent;
}

.align-self-center {
    align-self: center;
}

.large-thumb {
    position: relative;
}
#ods-img {
    filter: invert(1);
    position: absolute;
    z-index: 999;
    top: 13rem;
    left: 17rem;
    width: 13rem;
}

@media only screen and (min-width: 1200px) {
    .fix-chart {
        width: 50%;
        margin-left: auto;
        margin-right: auto;
    }
}

@media only screen and (min-width: 1200px) and (max-width: 1599px)
{
    #ods-img {
        width: 13rem !important;
        left: 17rem !important;
    }
}

</style>